<template>
<!-- 16×16 geometry (IconBase default viewBox). Path was previously 24-box coords. -->
<path d="M3 8.5l3.5 3.5 6.5-7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>
